'use client'

import { Breakpoints } from '@fukku/styles/breakpoints'
import type { PointOfInterestImage } from 'landings/Home/Home.type'
import { pointOfInterestImageLoaderFactory } from 'landings/utils/pointOfInterestImageLoaderFactory'

import { getPointOfInterest } from '../../../utils/getPointOfInterest/getPointOfInterest'
import { BannerImage } from '../../Shared/BannerImage/BannerImage'

type HeroBannerImageProps = {
	readonly image: PointOfInterestImage
	readonly isAlwaysPortrait?: boolean
	readonly priority?: boolean
}

const SMALL_MEDIUM_HEIGHT = 375

const LARGE_HEIGHT = 440

export function HeroBannerSecondaryLinesImage({
	image,
	priority = false,
}: HeroBannerImageProps) {
	const heroBannerImageLoader = pointOfInterestImageLoaderFactory(
		getPointOfInterest({ image }),
		(width) => {
			if (width <= Breakpoints.large) {
				return SMALL_MEDIUM_HEIGHT
			}
			return LARGE_HEIGHT
		}
	)

	return (
		<BannerImage
			image={image}
			imageLoader={heroBannerImageLoader}
			priority={priority}
		/>
	)
}
